import styled, { css } from 'styled-components';
import { grey, red } from '@material-ui/core/colors';
import { CardArea as CA, CssButton as CBtn } from '../../styles';

import { LPText as LPT, CardFooter as CF, CardTextArea as CTA } from '../../../styles';

export const LPText = styled(LPT)`
  font-size: 0.8rem;
  color: var(--text-secondary-color);
  margin: 0 0 1em;
  padding: ${(props) => props.padding || 0};
  ${(props) => props.uppercase
    && css`
      text-transform: uppercase;
    `};
  ${(props) => props.stroked
    && css`
      text-decoration: line-through;
    `};
  ${(props) => props.grey
    && css`
      color: ${grey[600]};
    `};
  ${(props) => props.noMargin
    && css`
      margin: 0;
    `}
  ${(props) => props.large
    && css`
      font-size: 1.2em;
      font-weight: 200;
    `}
  ${(props) => props.mid
    && css`
      font-size: 0.8em;
    `}
  ${(props) => props.small
    && css`
      font-size: 0.7em;
    `}
  ${(props) => props.bold
    && css`
      font-weight: bold;
    `}
  ${(props) => props.red
    && css`
      color: ${red[600]};
    `}
  ${(props) => props.centered
    && css`
      align-items: center;
    `}
`;

export const CardArea = styled(CA)`
  flex-shrink: 0;
  background-color: inherit;
  padding: 1em 1em 8em 1em;
  ${(props) => props.noBorder
    && css`
      border: none;
    `};
`;

export const CardTextArea = styled(CTA)`
  margin-bottom: 0.5em;
  ${(props) => props.bordered
    && css`
      border: 1px solid var(--border-color);
      border-width: 1px 0;
    `}
  ${(props) => props.noMargin
    && css`
      margin: 0;
    `}
`;

export const CardFooter = styled(CF)``;
export const CssButton = styled(CBtn)`
  flex: 1 0 auto;
  ${(props) => props.variant !== 'outlined'
    && css`
      background-color: ${grey[900]};
      color: ${grey[50]};
      border: none;
    `}
  .MuiButton-label {
    line-height: 1.4;
    font-size: 0.8rem;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color || 'inherit'};
  cursor: pointer;
  font-size: 1.4em;
`;
export const inputStyles = {
  root: {
    color: 'inherit',
  },
};
